import styled from "styled-components"
import Button from "../../components/Button";

export const Container = styled.div`
    display: flex;
    padding: 100px 150px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    
    h2{
        font-size: 1.875;
    }

    p{
        font-size: 1.2rem;
        margin-bottom: 15px;
    }
`

export const ContainerForm = styled.div`
    background-color: var(--primary-light);
    padding: 35px;
    width: 370px;
`
export const Form = styled.form`
    width: 100%;
`

export const Label = styled.div`
    display: flex;
    margin-bottom: 10px;
    font-weight: 600;
`
export const CustomButton = styled(Button)`
  margin-top: 10px;
`;